import { render, staticRenderFns } from "./preview-asset-cognitivetest.vue?vue&type=template&id=41149df5&scoped=true&"
import script from "./preview-asset-cognitivetest.vue?vue&type=script&lang=ts&"
export * from "./preview-asset-cognitivetest.vue?vue&type=script&lang=ts&"
import style0 from "./preview-asset-cognitivetest.vue?vue&type=style&index=0&id=41149df5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41149df5",
  null
  
)

export default component.exports